module.exports = __webpack_public_path__ + "static/media/crownOff_118.85924053.png";